import {css} from '@emotion/react'
import {
  IconChevronLeft,
  IconDoubleChevronLeft,
  IconChevronRight,
  IconDoubleChevronRight,
} from '@kensho/icons'

const paginationRowCss = css`
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const buttonCss = css`
  align-items: center;
  border: 1px solid transparent;
  cursor: pointer;
  height: 30px;
  user-select: none;
  width: 30px;
  color: rgba(0, 0, 0, 0.95);
  padding: 0px;
  background: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:active:enabled {
    background: rgba(16, 22, 26, 0.15);
  }

  &:disabled {
    color: rgba(0, 0, 0, 0.35);
    cursor: not-allowed;
  }

  &:focus {
    outline: rgba(9, 129, 159, 0.5) solid 2px;
    outline-offset: 2px;
  }

  &:hover:enabled {
    background: rgba(16, 22, 26, 0.075);
  }
`

const pagesDescriptionCss = css`
  padding-right: 12px;
`

interface PaginationControlsProps {
  count: number
  page: number
  pageSize: number
  setPage: (page: number) => void
}

export default function PaginationControls({
  count,
  page,
  setPage,
  pageSize,
}: PaginationControlsProps): JSX.Element {
  const lastPage = Math.ceil(count / pageSize)
  return (
    <footer css={paginationRowCss}>
      <span css={pagesDescriptionCss}>
        {page * pageSize - pageSize + 1}-{Math.min(page * pageSize, count)} of {count}
      </span>

      <button
        aria-label="First"
        type="button"
        css={buttonCss}
        onClick={() => setPage(1)}
        disabled={page === 1}
      >
        <IconDoubleChevronLeft />
      </button>
      <button
        aria-label="Previous"
        type="button"
        css={buttonCss}
        onClick={() => setPage(page - 1)}
        disabled={page === 1}
      >
        <IconChevronLeft />
      </button>
      <button
        aria-label="Next"
        type="button"
        css={buttonCss}
        onClick={() => setPage(page + 1)}
        disabled={page === lastPage}
      >
        <IconChevronRight />
      </button>
      <button
        aria-label="Last"
        type="button"
        css={buttonCss}
        onClick={() => setPage(lastPage)}
        disabled={page === lastPage}
      >
        <IconDoubleChevronRight />
      </button>
    </footer>
  )
}
